import Marquee from "react-fast-marquee";

const ITEMS = [
  "Trusted Representation",
  "Strategic Negotiation",
  "Relentless Mindset",
  "Protecting The Future",
];

export const EditorialMarquee = ({ speed = 45 }) => (
  <div data-testid="marquee" className="py-10 border-y border-white/10 bg-[#050505] overflow-hidden">
    <Marquee speed={speed} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-[9vw] lg:text-[7vw] leading-none text-stroke px-8 select-none">{t}</span>
          <span className="text-[#cbd1d8] text-[6vw] lg:text-[4vw] px-2">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
